export class User {
  constructor(
    public readonly name: string,
    public readonly surname: string,
    public readonly email: string,
    public readonly language: string,
    public readonly isGuest: boolean,
    public readonly telephone? : string
  ) { }
}